import React from 'react';

const Separator = () => {
  return (
    <div className='tw-flex tw-items-center tw-gap-5 tw-my-16 tw-justify-center'>
      <div className='tw-h-[1px] tw-bg-grey-300/70 tw-w-[5rem]' />
      <div className='tw-font-medium tw-text-zinc-700 tw-whitespace-nowrap tw-leading-none tw-mb-1'>
        OR
      </div>
      <div className='tw-h-[1px] tw-bg-grey-300/70 tw-w-[5rem]' />
    </div>
  );
};

export default Separator;
